export { default as LoyaltyPointsAndRewardsWidget } from './loyalty-points-rewards-widget';
